import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    font-family: sans-serif;
    box-sizing: border-box;
    outline: none;
    line-height: inherit;
    color: inherit;
  }
  body {
    background: #ffeff7;
    line-height: 1;
    color: #444;
  }
`;

export const CheckoutForm = styled.form`
  overflow: hidden;
  width: 600px;
  max-width: calc(100vw - 60px);
  margin: 30px auto;
  background: #fff;
  padding: 50px 30px;
  border-radius: 4px;
  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.1);
`;

export const CheckoutFormHeader = styled.div`
  margin: 40px 0 30px;
  text-align: center;
  img {
    height: 94px;
  }
`;

export const FormLabel = styled.label`
  display: block;
  font-weight: bold;
  font-size: 16px;
  input,
  select {
    display: block;
    font: inherit;
    font-weight: normal;
    margin-top: 5px;
    width: 100%;
    height: 40px;
    padding: 0 7px;
    border-radius: 0;
    border: none;
    border-bottom: 2px solid #bbb;
    transition: border-color 0.4s;
    &:focus {
      border-color: green;
    }
  }
`;

export const Button = styled.button`
  font-size: 16px;
  color: #fff;
  background: #a32563;
  padding: 15px 25px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  border: 1px solid rgba(0, 0, 0, 0.1);
  &:hover {
    opacity: 0.9;
  }
  &[disabled] {
    cursor: not-allowed;
    opacity: 0.8;
  }
`;

export const Footer = styled.footer`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 600px;
  max-width: calc(100vw - 60px);
  margin: 30px auto;
  padding: 0 30px;
  font-size: 14px;
`;

const LoaderIcon = styled.svg`
  @keyframes spin {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(359deg);
    }
  }
  animation: spin 0.6s linear 0s infinite;
`;

export const Loader = () => (
  <LoaderIcon width="64" height="64" viewBox="0 0 410 410">
    <path
      fill="#777"
      d="M205 410C91.7816 410 0 318.218 0 205C0 91.7816 91.7816 0 205 0C318.218 0 410 91.7816 410 205H379C379 108.902 301.098 31 205 31C108.902 31 31 108.902 31 205C31 301.098 108.902 379 205 379V410Z"
    />
  </LoaderIcon>
);
